module.exports = __webpack_public_path__ + "static/private-cloudfront-config-5-46aa934646cf075c9faab8aa894cdc1a.png";